__turbopack_context__.v({
  "accountAvatar": "AppChrome-module__zUdxpa__accountAvatar",
  "actions": "AppChrome-module__zUdxpa__actions",
  "avatarBtn": "AppChrome-module__zUdxpa__avatarBtn",
  "deskNav": "AppChrome-module__zUdxpa__deskNav",
  "deskNavCompact": "AppChrome-module__zUdxpa__deskNavCompact",
  "deskNavIcon": "AppChrome-module__zUdxpa__deskNavIcon",
  "deskNavItem": "AppChrome-module__zUdxpa__deskNavItem",
  "deskNavLabel": "AppChrome-module__zUdxpa__deskNavLabel",
  "deskNavLink": "AppChrome-module__zUdxpa__deskNavLink",
  "deskNavLinkActive": "AppChrome-module__zUdxpa__deskNavLinkActive",
  "deskNavList": "AppChrome-module__zUdxpa__deskNavList",
  "footer": "AppChrome-module__zUdxpa__footer",
  "footerActions": "AppChrome-module__zUdxpa__footerActions",
  "footerBrand": "AppChrome-module__zUdxpa__footerBrand",
  "footerBrandZone": "AppChrome-module__zUdxpa__footerBrandZone",
  "footerInner": "AppChrome-module__zUdxpa__footerInner",
  "footerInstrument": "AppChrome-module__zUdxpa__footerInstrument",
  "footerInstrumentSep": "AppChrome-module__zUdxpa__footerInstrumentSep",
  "footerLinks": "AppChrome-module__zUdxpa__footerLinks",
  "footerMeta": "AppChrome-module__zUdxpa__footerMeta",
  "footerStatusLink": "AppChrome-module__zUdxpa__footerStatusLink",
  "iconBtn": "AppChrome-module__zUdxpa__iconBtn",
  "iconBtnCurrent": "AppChrome-module__zUdxpa__iconBtnCurrent",
  "idBtn": "AppChrome-module__zUdxpa__idBtn",
  "link": "AppChrome-module__zUdxpa__link",
  "location": "AppChrome-module__zUdxpa__location",
  "mobileSearchItem": "AppChrome-module__zUdxpa__mobileSearchItem",
  "navLeft": "AppChrome-module__zUdxpa__navLeft",
  "navLeftSearchExpanded": "AppChrome-module__zUdxpa__navLeftSearchExpanded",
  "navRight": "AppChrome-module__zUdxpa__navRight",
  "navbar": "AppChrome-module__zUdxpa__navbar",
  "navbarMobile": "AppChrome-module__zUdxpa__navbarMobile",
  "navbarRaised": "AppChrome-module__zUdxpa__navbarRaised",
  "navbarSearchExpanded": "AppChrome-module__zUdxpa__navbarSearchExpanded",
  "nt-r26-none": "AppChrome-module__zUdxpa__nt-r26-none",
  "search": "AppChrome-module__zUdxpa__search",
  "searchClear": "AppChrome-module__zUdxpa__searchClear",
  "searchDropdown": "AppChrome-module__zUdxpa__searchDropdown",
  "searchDropdownHeader": "AppChrome-module__zUdxpa__searchDropdownHeader",
  "searchDropdownIn": "AppChrome-module__zUdxpa__searchDropdownIn",
  "searchDropdownTitle": "AppChrome-module__zUdxpa__searchDropdownTitle",
  "searchEmpty": "AppChrome-module__zUdxpa__searchEmpty",
  "searchEmptyHint": "AppChrome-module__zUdxpa__searchEmptyHint",
  "searchEmptyTitle": "AppChrome-module__zUdxpa__searchEmptyTitle",
  "searchField": "AppChrome-module__zUdxpa__searchField",
  "searchInput": "AppChrome-module__zUdxpa__searchInput",
  "searchInputExpanded": "AppChrome-module__zUdxpa__searchInputExpanded",
  "searchResult": "AppChrome-module__zUdxpa__searchResult",
  "searchResultCopy": "AppChrome-module__zUdxpa__searchResultCopy",
  "searchResultCount": "AppChrome-module__zUdxpa__searchResultCount",
  "searchResultDescription": "AppChrome-module__zUdxpa__searchResultDescription",
  "searchResultIcon": "AppChrome-module__zUdxpa__searchResultIcon",
  "searchResultInner": "AppChrome-module__zUdxpa__searchResultInner",
  "searchResultSelected": "AppChrome-module__zUdxpa__searchResultSelected",
  "searchResultTag": "AppChrome-module__zUdxpa__searchResultTag",
  "searchResultTitle": "AppChrome-module__zUdxpa__searchResultTitle",
  "searchResultsList": "AppChrome-module__zUdxpa__searchResultsList",
  "searchShortcut": "AppChrome-module__zUdxpa__searchShortcut",
  "searchShortcutKey": "AppChrome-module__zUdxpa__searchShortcutKey",
  "searchSlot": "AppChrome-module__zUdxpa__searchSlot",
  "searchSlotExpanded": "AppChrome-module__zUdxpa__searchSlotExpanded",
  "searchWrap": "AppChrome-module__zUdxpa__searchWrap",
  "searchWrapExpanded": "AppChrome-module__zUdxpa__searchWrapExpanded",
  "session": "AppChrome-module__zUdxpa__session",
  "statusActionBtn": "AppChrome-module__zUdxpa__statusActionBtn",
  "statusActionBtnGhost": "AppChrome-module__zUdxpa__statusActionBtnGhost",
  "statusActionLabel": "AppChrome-module__zUdxpa__statusActionLabel",
  "statusActions": "AppChrome-module__zUdxpa__statusActions",
  "statusChannel": "AppChrome-module__zUdxpa__statusChannel",
  "statusClosed": "AppChrome-module__zUdxpa__statusClosed",
  "statusConn": "AppChrome-module__zUdxpa__statusConn",
  "statusConnection": "AppChrome-module__zUdxpa__statusConnection",
  "statusDot": "AppChrome-module__zUdxpa__statusDot",
  "statusDown": "AppChrome-module__zUdxpa__statusDown",
  "statusError": "AppChrome-module__zUdxpa__statusError",
  "statusIcon": "AppChrome-module__zUdxpa__statusIcon",
  "statusItem": "AppChrome-module__zUdxpa__statusItem",
  "statusMark": "AppChrome-module__zUdxpa__statusMark",
  "statusMarket": "AppChrome-module__zUdxpa__statusMarket",
  "statusMuted": "AppChrome-module__zUdxpa__statusMuted",
  "statusOk": "AppChrome-module__zUdxpa__statusOk",
  "statusPanel": "AppChrome-module__zUdxpa__statusPanel",
  "statusPill": "AppChrome-module__zUdxpa__statusPill",
  "statusPulse": "AppChrome-module__zUdxpa__statusPulse",
  "statusReadout": "AppChrome-module__zUdxpa__statusReadout",
  "statusReadoutError": "AppChrome-module__zUdxpa__statusReadoutError",
  "statusReadoutMuted": "AppChrome-module__zUdxpa__statusReadoutMuted",
  "statusReadoutOk": "AppChrome-module__zUdxpa__statusReadoutOk",
  "statusReadoutWarn": "AppChrome-module__zUdxpa__statusReadoutWarn",
  "statusSep": "AppChrome-module__zUdxpa__statusSep",
  "statusText": "AppChrome-module__zUdxpa__statusText",
  "statusTime": "AppChrome-module__zUdxpa__statusTime",
  "statusValue": "AppChrome-module__zUdxpa__statusValue",
  "statusWarn": "AppChrome-module__zUdxpa__statusWarn",
  "toolText": "AppChrome-module__zUdxpa__toolText",
  "topBtn": "AppChrome-module__zUdxpa__topBtn",
  "topBtnCaret": "AppChrome-module__zUdxpa__topBtnCaret",
  "upgradeCta": "AppChrome-module__zUdxpa__upgradeCta",
  "upgradeCtaLabel": "AppChrome-module__zUdxpa__upgradeCtaLabel",
  "upgradeCtaMark": "AppChrome-module__zUdxpa__upgradeCtaMark",
});
